"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },

  /*
  perspective: {
      perspective: "1000px",
      perspectiveOriginX: "25%",
      perspectiveOriginY: "75%",
  },
  transform: {
      transform: "rotateY(-45deg)",
  },
  */
  format: {
    position: "relative",
    width: "100%",
    paddingBottom: props => {
      return props.paddingBottom;
    }
  }
}));

const PreviewFormat = ({
  format,
  children
}) => {
  let paddingBottom;

  if (format) {
    const size = format.split(":");
    const w = size[0];
    const h = size[1];
    const ratio = h / w;
    paddingBottom = ratio * 100 + "%";
  }

  const classes = useStyles({
    paddingBottom
  });

  if (paddingBottom) {
    return _react.default.createElement("div", {
      className: classes.root
    }, _react.default.createElement("div", {
      className: classes.format,
      "data-format": format
    }, children));
  }

  return children;
};

var _default = PreviewFormat;
exports.default = _default;
module.exports = exports.default;